import React from 'react';
import { useStore } from '../../store/useStore';
import { CheckCircle2, Link as LinkIcon, Shield, Info } from 'lucide-react';
export function Settings() {
  const {
    posConnected,
    setPosConnected
  } = useStore();
  const posProviders = ['Dutchie', 'Flowhub', 'Treez', 'Jane', 'Cova'];
  return <div className="max-w-3xl mx-auto space-y-8" data-id="element-286">
      <div data-id="element-287">
        <h1 className="text-3xl font-bold text-[#252935] mb-2" data-id="element-288">Settings</h1>
        <p className="text-[#60646F]" data-id="element-289">
          Manage your Stash configuration and integrations.
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-[rgba(37,41,53,0.12)] overflow-hidden" data-id="element-290">
        <div className="p-6 border-b border-[rgba(37,41,53,0.12)]" data-id="element-291">
          <div className="flex items-center gap-3 mb-2" data-id="element-292">
            <LinkIcon className="w-5 h-5 text-[#252935]" data-id="element-293" />
            <h2 className="text-xl font-bold text-[#252935]" data-id="element-294">
              POS Integration
            </h2>
          </div>
          <p className="text-[#60646F] mb-6" data-id="element-295">
            Connect your point-of-sale system to automate Stash verification.
            <strong data-id="element-296">
              {' '}
              Note: Stash works perfectly fine without a POS connection
            </strong>
            , you just confirm pickups manually.
          </p>

          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-[rgba(37,41,53,0.12)] mb-6" data-id="element-297">
            <div data-id="element-298">
              <h3 className="font-bold text-[#252935]" data-id="element-299">
                Simulate POS Connection (Demo)
              </h3>
              <p className="text-sm text-[#60646F]" data-id="element-300">
                Toggle this to see how the dashboard behaves with an active POS
                feed.
              </p>
            </div>
            <button onClick={() => setPosConnected(!posConnected)} className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors ${posConnected ? 'bg-[#00CDBE]' : 'bg-gray-300'}`} data-id="element-301">
              <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${posConnected ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-302" />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-303">
            {posProviders.map(provider => <div key={provider} className="flex items-center justify-between p-4 border border-[rgba(37,41,53,0.12)] rounded-xl" data-id="element-304">
                <span className="font-bold text-[#252935]" data-id="element-305">{provider}</span>
                <button className="px-4 py-1.5 bg-white border border-[rgba(37,41,53,0.12)] rounded-full text-sm font-bold text-[#252935] hover:bg-gray-50" data-id="element-306">
                  Connect
                </button>
              </div>)}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-[rgba(37,41,53,0.12)] overflow-hidden" data-id="element-307">
        <div className="p-6" data-id="element-308">
          <div className="flex items-center gap-3 mb-4" data-id="element-309">
            <Shield className="w-5 h-5 text-[#252935]" data-id="element-310" />
            <h2 className="text-xl font-bold text-[#252935]" data-id="element-311">
              The Stash Guarantee
            </h2>
          </div>
          <p className="text-[#60646F] mb-4" data-id="element-312">
            When a shopper reserves a Stashed item, we guarantee the price and
            availability. If they report a discrepancy at pickup (and it's
            verified), Weedmaps makes them whole with a credit.
          </p>
          <p className="text-[#60646F]" data-id="element-313">
            Failed pickups count against your store's accuracy score.
            Maintaining high accuracy keeps your items Stashed.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-[rgba(37,41,53,0.12)] overflow-hidden" data-id="element-314">
        <div className="p-6" data-id="element-315">
          <div className="flex items-center gap-3 mb-4" data-id="element-316">
            <Info className="w-5 h-5 text-[#252935]" data-id="element-317" />
            <h2 className="text-xl font-bold text-[#252935]" data-id="element-318">
              How the badge is earned
            </h2>
          </div>
          <p className="text-[#60646F] mb-4" data-id="element-319">
            A listing earns the Stashed badge automatically when three
            conditions are met:
          </p>
          <ul className="space-y-3" data-id="element-320">
            <li className="flex items-start gap-3" data-id="element-321">
              <CheckCircle2 className="w-5 h-5 text-[#00CDBE] shrink-0 mt-0.5" data-id="element-322" />
              <span className="text-[#252935]" data-id="element-323">
                <strong data-id="element-324">In stock:</strong> The item is marked available on your
                menu.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-325">
              <CheckCircle2 className="w-5 h-5 text-[#00CDBE] shrink-0 mt-0.5" data-id="element-326" />
              <span className="text-[#252935]" data-id="element-327">
                <strong data-id="element-328">High accuracy:</strong> Your recent pickups for this
                category have matched what was reserved.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-329">
              <CheckCircle2 className="w-5 h-5 text-[#00CDBE] shrink-0 mt-0.5" data-id="element-330" />
              <span className="text-[#252935]" data-id="element-331">
                <strong data-id="element-332">Fresh data:</strong> The inventory has been confirmed
                recently (via POS or manual pickup).
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>;
}